const unsplashKey = '0yApHxp38d977mVjGqykkmrFBgSdookXMAxuGJ3ZeNM';

export default unsplashKey;
